/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Contact_Code_Trees_Modified_UtcInputs */

const en_tables_contact_code_trees_modified_utc = /** @type {(inputs: Tables_Contact_Code_Trees_Modified_UtcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utc`)
};

const de_tables_contact_code_trees_modified_utc = /** @type {(inputs: Tables_Contact_Code_Trees_Modified_UtcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utc`)
};

/**
* | output |
* | --- |
* | "Utc" |
*
* @param {Tables_Contact_Code_Trees_Modified_UtcInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_contact_code_trees_modified_utc = /** @type {((inputs?: Tables_Contact_Code_Trees_Modified_UtcInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Contact_Code_Trees_Modified_UtcInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_contact_code_trees_modified_utc(inputs)
	return de_tables_contact_code_trees_modified_utc(inputs)
});